document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    if (window.innerWidth >= 768) return;

    const galleryWrapper = document.querySelector(
      '.grid__item.product__media-wrapper'
    );

    const customizer = document.getElementById('tee-artwork-form');

    if (!galleryWrapper || !customizer) return;

    const style = document.createElement('style');

    style.textContent = `
      body.tee-mobile-sticky:not(.tee-mobile-hidden)
      .grid__item.product__media-wrapper .tee-gallery-content {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: auto !important;
        background: #ffffff;
        z-index: 9998;
        padding: 10px 0;
        box-shadow: 0 2px 8px rgba(0,0,0,.15);
        display: flex;
        justify-content: center;
      }

      body.tee-mobile-sticky:not(.tee-mobile-hidden)
      .grid__item.product__media-wrapper #tee-gallery {
        transform: scale(.58);
        transform-origin: top center;
      }

      body.tee-mobile-sticky:not(.tee-mobile-hidden)
      .grid__item.product__media-wrapper .tee-thumbnails,
      body.tee-mobile-sticky:not(.tee-mobile-hidden)
      .grid__item.product__media-wrapper .tee-slider__dots {
        display: none !important;
      }

      .tee-mobile-close {
  display: none;
  position: fixed;
  top: 12px;
  right: 14px;
  z-index: 10000;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e00000;
  color: #ffffff;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0,0,0,.30);
  font-size: 26px;
  font-weight: bold;
  line-height: 31px;
  text-align: center;
  cursor: pointer;
}

      body.tee-mobile-sticky:not(.tee-mobile-hidden) .tee-mobile-close {
        display: block;
      }

      .tee-mobile-open {
        display: none;
        position: fixed;
        right: 18px;
        top: 100px;
        z-index: 10000;
        background: #ffffff;
        border: 1px solid #ddd;
        border-radius: 20px;
        padding: 8px 12px;
        box-shadow: 0 2px 6px rgba(0,0,0,.2);
        font-size: 13px;
        cursor: pointer;
      }

      body.tee-mobile-sticky.tee-mobile-hidden .tee-mobile-open {
        display: block;
      }
    `;

    document.head.appendChild(style);

    const closeButton = document.createElement('div');
    closeButton.className = 'tee-mobile-close';
    closeButton.innerHTML = '&times;';
    document.body.appendChild(closeButton);

    const openButton = document.createElement('div');
    openButton.className = 'tee-mobile-open';
    openButton.textContent = 'Show Preview';
    document.body.appendChild(openButton);

    closeButton.addEventListener('click', function () {
      document.body.classList.add('tee-mobile-hidden');
    });

    openButton.addEventListener('click', function () {
      document.body.classList.remove('tee-mobile-hidden');
    });

    function checkStickyGallery() {
      const galleryRect = galleryWrapper.getBoundingClientRect();
      const formRect = customizer.getBoundingClientRect();

      const galleryIsAboveScreen = galleryRect.bottom < 0;
      const customizerStillVisible = formRect.bottom > 250;

      if (galleryIsAboveScreen && customizerStillVisible) {
        document.body.classList.add('tee-mobile-sticky');
      } else {
        document.body.classList.remove(
          'tee-mobile-sticky',
          'tee-mobile-hidden'
        );
      }
    }

    window.addEventListener('scroll', checkStickyGallery, {
      passive: true
    });

    checkStickyGallery();
  }, 2000);
});